import styled from "styled-components";
import colours from "styles/colours";
import fonts from "styles/fonts";
import { fontWeights } from "styles/fonts";

export const UploadSection = styled.section`
  margin-top: 2rem;
`;

export const DropZone = styled.div<{ isDragOver: boolean }>`
  border: 2px dashed
    ${({ isDragOver }): string =>
      isDragOver ? colours.elexonBlue : colours.elexonGrey};
  border-radius: 8px;
  padding: 2.5rem 2rem;
  text-align: center;
  transition: 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: ${colours.elexonBlue};
  }
`;

export const UploadIcon = styled.div`
  margin-bottom: 1rem;
  color: ${colours.mediumGrey};
  font-size: ${fonts.large};
`;

export const DropZoneText = styled.p`
  font-size: ${fonts.small};
  color: ${colours.darkGrey};
  margin-bottom: 0.75rem;
`;

export const SelectedFileContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  margin: 0.75rem;
  padding: 0.5rem 1rem;
`;

export const SelectedFileName = styled.span`
  font-size: ${fonts.medium};
  font-weight: ${fontWeights.semiBold};
  color: ${colours.elexonBlue};
`;

export const RemoveFileButton = styled.button`
  background: none;
  border: none;
  color: ${colours.elexonRed};
  cursor: pointer;
  font-size: ${fonts.small};
  font-weight: ${fontWeights.bold};
  padding: 0.4rem;
  border-radius: 50%;
  width: 1.8rem;
  height: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${colours.fadedRed};
  }
`;

export const SubmitButtonContainer = styled.div`
  margin-top: 1.5rem;
`;

export const ErrorText = styled.div`
  color: ${colours.elexonRed};
  font-size: ${fonts.small};
  margin-top: 0.5rem;
`;
